<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { globalStatus }  from "@/helpers/helper"
import OdemeAl from "./odeme_al"
import SatisEkle from "./satis_ekle"
import OdemeGecmisi from "./odeme_gecmisi"
import DuzeltmeDetay from './duzeltme_detay.vue'

export default {
  page: {
    title: "Bayi Bakiye Hareket",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    OdemeAl,
    OdemeGecmisi,
    SatisEkle,
    DuzeltmeDetay
  },
  data() { 
    return {
        list: {},
        title: "BAYİ BAKİYE HAREKETLERİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "BAYİ BAKİYE HAREKETLERİ",
            active: true,
          },
        ],
        isLoading: false,
        detailSearch:true,
        form:{
          company:1
        },
        modalOpenCount: 0,
        duzeltmeData:{},
        odemeGecmisiDetay:{},
        odemeAlDetay:{},
        satisEkleDetay:{},
        rows: [],
        buttons:[
            { title:"Tahsilat Ekle", icon:'bx bx-credit-card', func:this.odemeAl},
            { title:"Satış Ekle", icon:'bx bx-cart-add', func:this.satis},
            { title:"Güncel Ödeme Geçmişi", icon:'bx bx-history', func:this.odemeGecmisi},
            { title:"Ödeme Düzeltme Logları", icon:'bx bx-layer', func:this.logs},
        ],  
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "/dealers/balances",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa',
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
        {
          label: 'İsim Soyisim',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'İsim Soyisim Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Kullanıcı Adı Filtrele',
            filterDropdownItems: [ ],
          },
        },
        {
          label: 'Bakiye',
          field: 'credit',
          sortable: false,
          tdClass:'text-end',
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  computed: {
    companyLabel() {
      return this.form.company == 2 ? 'Elworks' : 'Primenet';
    },
    totalBalance() {
      return this.rows.reduce((sum, row) => sum + parseFloat(row.balance || 0), 0);
    },
    totalCollect() {
      return this.rows.reduce((sum, row) => sum + parseFloat(row.collect || 0), 0);
    },
    totalCredit() {
      return this.rows.reduce((sum, row) => sum + parseFloat(row.credit || 0), 0);
    },
  },
  mounted() {
    this.date()
    this.loadItems()
  },
  methods: {
    date(){
        //var currentDate = new Date();
        //var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        //var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        //this.form.startdate= this.formatDate(firstDay),
        //this.form.startdateend= this.formatDate(lastDay)
    },

    formatDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        
        return year + '-' + month + '-' + day;
    },
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.isLoading = true
      this.getFromServer(this.serverParams).then(response => {
        this.rows = response.rows
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    formSubmit() {
        this.updateParams({ columnFilters : this.form})
        this.loadItems()
    },
    clearDates() {
      this.form.startdate = ''
      this.form.startdateend = ''
    },
    odemeGecmisi(props){
       this.odemeGecmisiDetay = { ...this.form, id : props.id, name:props.name }
       this.$parent.$bvModal.show('odeme_gecmisi')
    }, 
    logs(props){
      // eslint-disable-next-line no-console
      console.log(props, this.from)
      this.duzeltmeData = { ...this.form, user_id : props.id, user_name:props.name }
      this.modalOpenCount += 1;
      this.$parent.$bvModal.show('duzeltme_gecmisi')
    }, 
    odemeAl(props){
       this.odemeAlDetay = props
       this.$parent.$bvModal.show('odeme_al')
    },
    satis(props){
      this.satisEkleDetay = props
      this.$parent.$bvModal.show('satis_ekle')
    },
    filter(val){
      if(val.length < 3) return

        this.updateParams({ columnFilters : this.form })
        this.loadItems()
    },
    async excelExport() {

        const currentDate = new Date();

        const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_Tahsilatlar.xlsx`;

        this.$http.post('/dealers/balances?excel=true', this.serverParams, { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
        
    },
  },
};
</script>

<template>
  <Layout>
    <OdemeAl :data="odemeAlDetay" />
    <OdemeGecmisi :data="odemeGecmisiDetay"  />
    <SatisEkle :data="satisEkleDetay" />
    <DuzeltmeDetay 
      :data="duzeltmeData" 
      :open="modalOpenCount" 
       @loadItems="loadItems"
      />

    <PageHeader :title="title" :items="items" />

    <div class="sahsi-page">
      <div class="sahsi-toolbar">
        <button type="button" class="sahsi-btn sahsi-btn--success" @click="excelExport">
          <i class="bx bx-download"></i>
          Excel'e Al
        </button>
        <button
          type="button"
          class="sahsi-btn sahsi-btn--ghost"
          :class="{ 'is-active': detailSearch }"
          @click="detailSearch = !detailSearch"
        >
          <i class="bx bx-filter-alt"></i>
          Detaylı Arama
        </button>
      </div>

      <Transition name="fade">
        <div class="sahsi-filter" v-if="detailSearch">
          <div class="sahsi-filter__head">
            <div>
              <p class="sahsi-filter__eyebrow">Filtre</p>
              <h5 class="sahsi-filter__title">Bakiye Hareket Raporu</h5>
            </div>
            <div class="sahsi-filter__badges">
              <span class="sahsi-filter__range-badge">
                <i class="bx bx-buildings"></i>
                {{ companyLabel }}
              </span>
              <span class="sahsi-filter__range-badge" v-if="form.startdate && form.startdateend">
                <i class="bx bx-calendar"></i>
                {{ form.startdate }} — {{ form.startdateend }}
              </span>
            </div>
          </div>
          <form class="sahsi-filter__form" @submit.prevent="formSubmit">
            <div class="sahsi-field sahsi-field--company">
              <label>Şirket</label>
              <select v-model="form.company" class="sahsi-input">
                <option value="1">Primenet</option>
                <option value="2">Elworks</option>
              </select>
            </div>
            <div class="sahsi-filter__dates">
              <div class="sahsi-field">
                <label>
                  Başlangıç
                  <button type="button" class="sahsi-clear" v-if="form.startdate || form.startdateend" @click="clearDates()">Temizle</button>
                </label>
                <input type="date" class="sahsi-input" v-model="form.startdate">
              </div>
              <span class="sahsi-filter__sep">—</span>
              <div class="sahsi-field">
                <label>Bitiş</label>
                <input type="date" class="sahsi-input" v-model="form.startdateend">
              </div>
            </div>
            <button type="submit" class="sahsi-btn sahsi-btn--primary" :disabled="isLoading">
              <i class="bx bx-search-alt" :class="{ 'bx-spin': isLoading }"></i>
              Sorgula
            </button>
          </form>
        </div>
      </Transition>

      <div class="sahsi-search">
        <i class="bx bx-search sahsi-search__icon"></i>
        <input
          type="text"
          class="sahsi-search__input"
          placeholder="En az 3 karakter giriniz!"
          v-model="form.query"
          @keyup="filter($event.target.value)"
        />
      </div>

      <div class="sahsi-summary" v-if="!isLoading && rows.length">
        <div class="sahsi-summary__item">
          <span class="sahsi-summary__label">Kayıt Sayısı</span>
          <strong class="sahsi-summary__value">{{ rows.length }}</strong>
        </div>
        <div class="sahsi-summary__item">
          <span class="sahsi-summary__label">Tarih Aralığı Bakiye</span>
          <strong class="sahsi-summary__value">{{ $paraFormat(totalBalance) }}</strong>
        </div>
        <div class="sahsi-summary__item">
          <span class="sahsi-summary__label">Tahsilat</span>
          <strong class="sahsi-summary__value sahsi-summary__value--collect">{{ $paraFormat(totalCollect) }}</strong>
        </div>
        <div class="sahsi-summary__item sahsi-summary__item--total">
          <span class="sahsi-summary__label">Güncel Bakiye</span>
          <strong class="sahsi-summary__value">{{ $paraFormat(totalCredit) }}</strong>
        </div>
      </div>

      <div class="sahsi-panel" :class="{ 'is-loading': isLoading }">
        <div class="sahsi-panel__header">
          <div>
            <h5 class="sahsi-panel__title"><i class="bx bx-transfer-alt me-2"></i>Bayi Bakiye Listesi</h5>
            <p class="sahsi-panel__sub" v-if="form.startdate && form.startdateend">
              Tarih aralığı: {{ form.startdate }} — {{ form.startdateend }}
            </p>
            <p class="sahsi-panel__sub" v-else>İşlem menüsünden tahsilat, satış ve geçmiş işlemlerine erişin</p>
          </div>
        </div>

        <div v-if="isLoading" class="sahsi-empty">
          <i class="bx bx-loader-alt bx-spin"></i>
          <p>Yükleniyor...</p>
        </div>

        <div v-else-if="rows.length === 0" class="sahsi-empty">
          <i class="bx bx-folder-open"></i>
          <p>Kayıt bulunamadı</p>
        </div>

        <div v-else class="sahsi-table-wrap">
          <div class="sahsi-table-head">
            <span class="sahsi-table-head__col sahsi-table-head__col--name">Bayi</span>
            <span class="sahsi-table-head__col">Tarih Aralığı Bakiye</span>
            <span class="sahsi-table-head__col">Tahsilat</span>
            <span class="sahsi-table-head__col">Bakiye</span>
            <span class="sahsi-table-head__col sahsi-table-head__col--action"></span>
          </div>

          <div
            v-for="(row, i) in rows"
            :key="i"
            class="sahsi-table-row"
          >
            <div class="sahsi-table-row__name">
              <span class="sahsi-row__avatar">{{ (row.name || '?').charAt(0).toUpperCase() }}</span>
              <strong>{{ row.name }}</strong>
            </div>
            <span class="sahsi-table-row__val">{{ $paraFormat(row.balance) }}</span>
            <span class="sahsi-table-row__val sahsi-table-row__val--collect">{{ $paraFormat(row.collect) }}</span>
            <span class="sahsi-table-row__val sahsi-table-row__val--credit">{{ $paraFormat(row.credit) }}</span>
            <div class="sahsi-table-row__action">
              <b-dropdown
                toggle-class="sahsi-action-toggle"
                toggle-tag="button"
                variant="white"
                right
                no-caret
              >
                <template #button-content>
                  <i class="bx bx-dots-horizontal-rounded"></i>
                </template>
                <b-dropdown-item
                  v-for="(button, idx) in buttons"
                  :key="idx"
                  @click="button.func(row)"
                >
                  <i :class="button.icon"></i> {{ button.title }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="sahsi-panel__footer sahsi-panel__footer--grid" v-if="!isLoading && rows.length">
          <span class="sahsi-panel__footer-label">Genel Toplam</span>
          <strong>{{ $paraFormat(totalBalance) }}</strong>
          <strong class="sahsi-panel__footer-collect">{{ $paraFormat(totalCollect) }}</strong>
          <strong>{{ $paraFormat(totalCredit) }}</strong>
          <span></span>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.sahsi-page { display: flex; flex-direction: column; gap: 20px; }
.sahsi-toolbar { display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap; }
.sahsi-filter { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 22px 24px; box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04); }
.sahsi-filter__head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 18px; flex-wrap: wrap; }
.sahsi-filter__badges { display: flex; flex-wrap: wrap; gap: 8px; }
.sahsi-filter__eyebrow { margin: 0 0 4px; font-size: 11px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #2563eb; }
.sahsi-filter__title { margin: 0; font-size: 1.05rem; font-weight: 700; color: #0f172a; }
.sahsi-filter__range-badge { display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; border-radius: 999px; background: #f1f5f9; font-size: 12px; font-weight: 600; color: #475569; }
.sahsi-filter__form { display: flex; align-items: flex-end; gap: 16px; flex-wrap: wrap; }
.sahsi-field--company { min-width: 160px; flex: 0 0 160px; }
.sahsi-filter__dates { display: flex; align-items: flex-end; gap: 12px; flex: 1; min-width: 280px; }
.sahsi-filter__sep { color: #94a3b8; padding-bottom: 10px; font-weight: 600; }
.sahsi-field { flex: 1; min-width: 140px; }
.sahsi-field label { display: flex; align-items: center; justify-content: space-between; font-size: 12px; font-weight: 600; color: #64748b; margin-bottom: 6px; }
.sahsi-clear { border: none; background: none; padding: 0; font-size: 11px; font-weight: 600; color: #ef4444; cursor: pointer; }
.sahsi-clear:hover { text-decoration: underline; }
.sahsi-input { width: 100%; height: 42px; padding: 0 12px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; color: #0f172a; background: #f8fafc; transition: border-color 0.2s, box-shadow 0.2s; }
.sahsi-input:focus { outline: none; border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); background: #fff; }
.sahsi-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; height: 42px; padding: 0 18px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: transform 0.15s, box-shadow 0.15s, background 0.15s; }
.sahsi-btn--primary { background: linear-gradient(135deg, #2563eb, #1d4ed8); color: #fff; box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25); }
.sahsi-btn--primary:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 22px rgba(37, 99, 235, 0.32); }
.sahsi-btn--success { background: linear-gradient(135deg, #059669, #047857); color: #fff; box-shadow: 0 6px 18px rgba(5, 150, 105, 0.22); }
.sahsi-btn--success:hover { transform: translateY(-1px); }
.sahsi-btn--ghost { background: #fff; border: 1px solid #e2e8f0; color: #475569; }
.sahsi-btn--ghost:hover, .sahsi-btn--ghost.is-active { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
.sahsi-btn:disabled { opacity: 0.7; cursor: not-allowed; }
.sahsi-search { position: relative; background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04); }
.sahsi-search__icon { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-size: 18px; color: #94a3b8; pointer-events: none; }
.sahsi-search__input { width: 100%; height: 44px; padding: 0 14px 0 42px; border: none; border-radius: 12px; font-size: 14px; color: #0f172a; background: transparent; outline: none; }
.sahsi-search__input::placeholder { color: #94a3b8; }
.sahsi-summary { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 14px; }
.sahsi-summary__item { background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 16px 20px; display: flex; flex-direction: column; gap: 4px; }
.sahsi-summary__item--total { background: linear-gradient(135deg, #ecfdf5, #f0fdf4); border-color: #bbf7d0; }
.sahsi-summary__label { font-size: 12px; color: #64748b; font-weight: 600; }
.sahsi-summary__value { font-size: 1.2rem; color: #0f172a; line-height: 1.2; }
.sahsi-summary__value--collect { color: #2563eb; }
.sahsi-summary__item--total .sahsi-summary__value { color: #059669; }
.sahsi-panel { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04); }
.sahsi-panel.is-loading { opacity: 0.85; }
.sahsi-panel__header { padding: 20px 22px 0; }
.sahsi-panel__title { margin: 0; font-size: 1rem; font-weight: 700; color: #0f172a; }
.sahsi-panel__sub { margin: 4px 0 0; font-size: 13px; color: #64748b; }
.sahsi-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; padding: 48px 20px; color: #94a3b8; }
.sahsi-empty i { font-size: 2.5rem; }
.sahsi-table-wrap { padding: 12px 16px 16px; }
.sahsi-table-head, .sahsi-table-row { display: grid; grid-template-columns: minmax(180px, 1.4fr) repeat(3, minmax(110px, 1fr)) 44px; align-items: center; gap: 12px; }
.sahsi-table-head { padding: 10px 14px; font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #eef2f7; }
.sahsi-table-head__col { text-align: right; }
.sahsi-table-head__col--name, .sahsi-table-head__col--action { text-align: left; }
.sahsi-table-row { padding: 12px 14px; border: 1px solid #eef2f7; border-radius: 12px; margin-top: 8px; background: #fafbfc; transition: background 0.15s, box-shadow 0.15s; }
.sahsi-table-row:hover { background: #f1f5f9; box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04); }
.sahsi-table-row__name { display: flex; align-items: center; gap: 10px; min-width: 0; }
.sahsi-table-row__name strong { font-size: 14px; color: #0f172a; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sahsi-row__avatar { width: 36px; height: 36px; border-radius: 10px; background: linear-gradient(135deg, #dbeafe, #bfdbfe); color: #1d4ed8; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sahsi-table-row__val { text-align: right; font-size: 14px; font-weight: 600; color: #334155; }
.sahsi-table-row__val--collect { color: #2563eb; }
.sahsi-table-row__val--credit { color: #059669; font-weight: 700; }
.sahsi-table-row__action { display: flex; justify-content: flex-start; }
.sahsi-action-toggle { width: 36px; height: 36px; padding: 0; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; color: #64748b; display: inline-flex; align-items: center; justify-content: center; }
.sahsi-action-toggle:hover { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
.sahsi-panel__footer { display: flex; align-items: center; justify-content: space-between; padding: 14px 22px; border-top: 1px solid #eef2f7; background: #f8fafc; font-size: 14px; color: #475569; }
.sahsi-panel__footer--grid { display: grid; grid-template-columns: minmax(180px, 1.4fr) repeat(3, minmax(110px, 1fr)) 44px; gap: 12px; padding: 14px 30px; align-items: center; }
.sahsi-panel__footer-label { font-weight: 600; }
.sahsi-panel__footer strong { text-align: right; font-size: 1rem; color: #0f172a; }
.sahsi-panel__footer-collect { color: #2563eb !important; }
@media (max-width: 991.98px) {
  .sahsi-table-head { display: none; }
  .sahsi-table-row { grid-template-columns: 1fr auto; grid-template-areas: "name action" "balance balance" "collect collect" "credit credit"; }
  .sahsi-table-row__name { grid-area: name; }
  .sahsi-table-row__action { grid-area: action; justify-content: flex-end; }
  .sahsi-table-row__val { text-align: left; }
  .sahsi-table-row__val::before { display: block; font-size: 11px; font-weight: 600; color: #94a3b8; margin-bottom: 2px; }
  .sahsi-table-row__val:nth-child(2)::before { content: 'Tarih Aralığı Bakiye'; }
  .sahsi-table-row__val:nth-child(3)::before { content: 'Tahsilat'; }
  .sahsi-table-row__val:nth-child(4)::before { content: 'Bakiye'; }
  .sahsi-panel__footer--grid { grid-template-columns: 1fr 1fr; }
  .sahsi-panel__footer--grid span:last-child { display: none; }
}
@media (max-width: 767.98px) {
  .sahsi-filter__form { flex-direction: column; align-items: stretch; }
  .sahsi-field--company { flex: 1; }
  .sahsi-filter__dates { flex-direction: column; align-items: stretch; }
  .sahsi-filter__sep { display: none; }
  .sahsi-toolbar { justify-content: stretch; }
  .sahsi-toolbar .sahsi-btn { flex: 1; }
}
</style>
